export enum POLICY_CHANGE_HISTORY_STATUS {
  PENDING = 'pending',
  COMPLETE = 'complete',
  CANCELLED = 'cancelled',
}

export enum POLICY_CHANGE_EDITOR {
  OPS = 'ops',
  ADVISOR = 'advisor',
  AUTO = 'auto',
}
